import type { TOC } from '@ember/component/template-only';
import TasBenefitHistory from 'tio-employee/components/tas/benefit-history';
import type { BenefitHistoryModel } from 'tio-employee/routes/authenticated/tas/benefit-history';

interface BenefitHistoryRouteSignature {
  Args: {
    model: BenefitHistoryModel;
  };
}

const tmpl: TOC<BenefitHistoryRouteSignature> = <template>
  <TasBenefitHistory @model={{@model}} />
</template>;

export default tmpl;
